import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { ConfirmFormStrategy } from './confirm-form.interface';

export interface ConfirmFormData {
  strategy: ConfirmFormStrategy;
  messageParams?: Record<string, string>;
}

@Component({
  selector: 'ocp-confirm-form',
  templateUrl: './confirm-form.component.html',
  styleUrls: ['./confirm-form.component.scss'],
  imports: [HlmButtonImports, TranslatePipe],
})
export class ConfirmFormComponent {
  protected readonly dynamicDialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef, {
    optional: true,
  });
  private readonly data = injectBrnDialogContext<ConfirmFormData>({ optional: true });
  protected readonly strategy = this.data?.strategy;
  protected readonly messageParams = this.data?.messageParams;

  protected onConfirm(): void {
    this.dynamicDialogRef?.close(true);
  }

  protected onCancel(): void {
    this.dynamicDialogRef?.close();
  }
}
